/** Import modules */

import { useEffect, useState } from "react";

import { useNavigate }      from "react-router-dom";

import { useLocation }      from "react-router-dom";

import { FaArrowDown }      from "react-icons/fa";

import { scrollElement }    from "../../../Misc/ScrollElement";

import { useTranslation }   from "react-i18next";

/** Import components */

import SearchableSelect     from "../../Shared/SearchableSelect";

/**
 *
 * @param { combinations, manufacturers, size } param0
 *
 * @returns Winter tyre size selector
 *
 */

const WinterSizeSelector = ( { combinations, manufacturers, size } ) => {

    const navigate = useNavigate (),

    { search } = useLocation (),

    { t } = useTranslation (),

    searchParams = new URLSearchParams ( search ),

    [ selected, setSelected ] = useState ( {

        width: size?.width || searchParams.get ( "w" ) || "default",

        height: size?.height || searchParams.get ( "h" ) || "default",

        diameter: size?.diameter || searchParams.get ( "d" ) || "default",

        manufacturer: searchParams.get ( "m" ) || "default",

        studs: searchParams.get ( "st" ) || "default"

    } );

    useEffect ( () => {

        setSelected ( {

            width: size?.width || searchParams.get ( "w" ) || "default",

            height: size?.height || searchParams.get ( "h" ) || "default",

            diameter: size?.diameter || searchParams.get ( "d" ) || "default",

            manufacturer: searchParams.get ( "m" ) || "default",

            studs: searchParams.get ( "st" ) || "default"

        } );

    }, [ search, size?.width, size?.height, size?.diameter ] );

    const normalizedCombinations = ( combinations || [] ).map ( combination => ( {

        width: parseFloat ( combination.width ).toString (),

        height: parseFloat ( combination.height ).toString (),

        diameter: parseFloat ( combination.diameter ).toString ()

    } ) ),

    matchingCombinations = excludedKey => normalizedCombinations.filter ( combination => [ "width", "height", "diameter" ].every ( key => {

        if ( key === excludedKey || selected[ key ] === "default" ) return true;

        return combination[ key ] === parseFloat ( selected[ key ] ).toString ();

    } ) ),

    uniqueOptions = key => [ ...new Set ( matchingCombinations ( key ).map ( combination => combination[ key ] ) ) ]

        .sort ( ( a, b ) => parseFloat ( a ) - parseFloat ( b ) )

        .map ( value => ( { text: value, value } ) ),

    options = {

        width: uniqueOptions ( "width" ),

        height: uniqueOptions ( "height" ),

        diameter: uniqueOptions ( "diameter" )

        ,

        manufacturer: manufacturers || []

    },

    formatDimension = value => parseFloat ( value ).toString (),

    scrollToProducts = () => {

        window.requestAnimationFrame ( () => window.requestAnimationFrame ( () => {

            if ( document.querySelector ( ".winter-tyres-page__products" ) ) scrollElement ( ".winter-tyres-page__products" );

        } ) );

    },

    selectDimension = ( key, value ) => {

        setSelected ( { ...selected, [ key ]: value } );

    },

    searchBySize = () => {

        const selectedDimensions = [ "width", "height", "diameter" ].filter ( key => selected[ key ] !== "default" ),

        allDimensionsSelected = selectedDimensions.length === 3,

        validCombination = normalizedCombinations.some ( combination => [ "width", "height", "diameter" ].every ( key => combination[ key ] === selected[ key ] ) ),

        cleanSize = `${ formatDimension ( selected.width ) }-${ formatDimension ( selected.height ) }-r${ formatDimension ( selected.diameter ) }`;

        if ( allDimensionsSelected && validCombination ) {

            const manufacturerParams = new URLSearchParams ();

            if ( selected.manufacturer !== "default" ) manufacturerParams.set ( "m", selected.manufacturer );

            if ( selected.studs !== "default" ) manufacturerParams.set ( "st", selected.studs );

            navigate ( {

                pathname: `/ziemas-riepas/${ cleanSize }`,

                search: manufacturerParams.toString () ? `?${ manufacturerParams.toString () }` : ""

            } );

            return scrollToProducts ();

        }

        const filters = new URLSearchParams ();

        if ( selected.width !== "default" ) filters.set ( "w", formatDimension ( selected.width ) );

        if ( selected.height !== "default" ) filters.set ( "h", formatDimension ( selected.height ) );

        if ( selected.diameter !== "default" ) filters.set ( "d", formatDimension ( selected.diameter ) );

        if ( selected.manufacturer !== "default" ) filters.set ( "m", selected.manufacturer );

        if ( selected.studs !== "default" ) filters.set ( "st", selected.studs );

        navigate ( {

            pathname: "/ziemas-riepas",

            search: filters.toString () ? `?${ filters.toString () }` : ""

        } );

        scrollToProducts ();

    };

    /** Return component */

    return ( <div className="winter-tyres-page__size-selector">

        <div className="winter-tyres-page__size-fields">

            <div>

                <label htmlFor="winter-tyre-width">{ t ( "width" ) }</label>

                <SearchableSelect

                    options={ options.width }

                    value={ selected.width }

                    onChange={ value => selectDimension ( "width", value ) }

                    type="FLOAT"

                    label={ t ( "select_option" ) }

                />

            </div>

            <div>

                <label htmlFor="winter-tyre-height">{ t ( "profile" ) }</label>

                <SearchableSelect

                    options={ options.height }

                    value={ selected.height }

                    onChange={ value => selectDimension ( "height", value ) }

                    type="FLOAT"

                    label={ t ( "select_option" ) }

                />

            </div>

            <div>

                <label htmlFor="winter-tyre-diameter">{ t ( "diameter" ) }</label>

                <SearchableSelect

                    options={ options.diameter }

                    value={ selected.diameter }

                    onChange={ value => selectDimension ( "diameter", value ) }

                    type="FLOAT"

                    formatOption={ option => `R ${ parseFloat ( option.value ).toString () }` }

                    label={ t ( "select_option" ) }

                />

            </div>

            <div>

                <label htmlFor="winter-tyre-manufacturer">{ t ( "manufacturer" ) }</label>

                <SearchableSelect

                    options={ manufacturers || [] }

                    value={ selected.manufacturer }

                    onChange={ value => selectDimension ( "manufacturer", value ) }

                    formatOption={ option => option.text ? `${ option.text.charAt ( 0 ).toUpperCase () }${ option.text.slice ( 1 ) }` : "" }

                    label={ t ( "select_option" ) }

                />

            </div>

        </div>

        <button

            className="winter-tyres-page__size-search"

            onClick={ searchBySize }

            aria-label={ t ( "search" ) }

            title={ t ( "search" ) }>

            <FaArrowDown aria-hidden="true" />

        </button>

    </div> );

}

/** Export component */

export default WinterSizeSelector;